import { NamedRoutes } from '@/app/core/services/named-router';

import { authGuard, guestGuard, profileResolverGuard } from '@/app/core/guards';

export const AppRoutes: NamedRoutes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadChildren: () => import('./auth/auth.routes').then((mod) => mod.AuthRoutes),
  },
  {
    path: '',
    canMatch: [authGuard, profileResolverGuard],
    loadChildren: () => import('./private/private.routes').then((mod) => mod.PrivateRoutes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
